import { CheckCircle, Icon, Info, WarningCircle, XCircle } from "@phosphor-icons/react";
import { Dialog, DialogProps } from "../../Dialog";
import { Modal } from "../styles";
import { ModalView, Type } from "./styles";
import { useStore } from "../../../store";
import { ReactNode } from "react";
import { Button, Size, Variant } from "../../Buttons";

export interface ConfirmModalProps extends Omit<DialogProps, "children">{
  type: Type;
  title: string;
  question: string;
  acceptText: string;
  acceptFunction: () => void;
  declineText: string;
  declineFunction: () => void;
  onClose: () => void;
};

export const ConfirmModal = ({
  open,
  type,
  title,
  question,
  acceptText,
  declineText,
  acceptFunction,
  declineFunction,
  onClose,
  ...rest
}: ConfirmModalProps ) => {
  const {
    theme,
  } = useStore();

  const getTypeIcon = ( type: Type ): ReactNode => {
    const typeIconMapper: {
      [ key in Type ]: Icon;
    } = {
      success: CheckCircle,
      info: Info,
      warning: WarningCircle,
      error: XCircle,
    };

    const Icon = typeIconMapper[ type ];

    return (
      <Icon
        weight="duotone"
        color={ theme.colors[ type ].default }
        size={ 40 }
      />
    );
  };

  return (
    <Dialog
      onClose={ onClose }
      open={ open }
      ariaLabel={ title }
      { ...rest }
    >
      <Modal>
        <ModalView
          $type={ type }
        >
          <div className="modal-header">
            {
              getTypeIcon( type )
            }

            <span>{ title }</span>
          </div>

          <div className="modal-body">
            <span>{ question }</span>
          </div>

          <div className="modal-actions">
            <Button
              $size={ Size.LARGE }
              $color={ type }
              $variant={ Variant.OUTLINED }
              onClick={ declineFunction }
            >
              { declineText }
            </Button>

            <Button
              $size={ Size.LARGE }
              $color={ type }
              onClick={() => {
                onClose();

                acceptFunction();
              }}
            >
              { acceptText }
            </Button>
          </div>
        </ModalView>
      </Modal>
    </Dialog>
  );
};
